import React from 'react';
import { Fade } from 'react-reveal';
import Image from '../components/Image';
import CakeBrand from '../images/cake-branding.svg';

const CakeIDContent = () => { 
  return (
  <div id={'main-content'}>        
    <section className={'project-detail-hero'} >
      <h1 className={'project-name two-piece-combo'} >
        <span className={'slide-top a1'}>NorthAB </span> 
        <span className={'slide-top a2'}>Product Suite </span>  
      </h1>
    <Fade >
      <div className={'contribution two-piece-combo'} >
        <div className={'icon'} >&#xF001;</div>
        <ul>
          <li>Point of Sale (Tabletop &amp; Handheld)</li>
          <li>Restaurant Admin</li>
          <li>Online Ordering</li>
        </ul>        
      </div>
    </Fade>
    </section>

    <Fade>
    <section className={'project-info'} >
      <div className={'project-copy two-piece-combo'} >
        <h2 className={'sub-head'} >
          Sorry
        </h2>
        
      </div>
      <div className={'project-copy two-piece-combo'} >
        <p>
          The contents of these projects cannot be shared publically. Please <a target="_blank" href="mailto:wes@weswongdesigns.com">contact me directly</a> for more information
        </p>

      </div>
    </section>
   
    </Fade>



  </div>

  )
}

export default CakeIDContent;